import { BackendResponse } from "../BackendResponse";
import { ITextAndTranslation } from "../translations/getStringsAndTranslations";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SetAdminSettingsResponse extends BackendResponse {
  items: string[];
}

export interface SetAdminSettingsParameters extends NextApiParams {
  idEmbed: string | null;
  settings: string[][];
  textsSettings: ITextAndTranslation[];
}

export const setSettings = withNextApi<
  SetAdminSettingsResponse,
  SetAdminSettingsParameters
>("/CvpSettings/CvpSetSettings");
